import React from 'react';

interface TeamsLogoProps {
  size?: number;
  className?: string;
}

const TeamsLogo: React.FC<TeamsLogoProps> = ({ size = 20, className = '' }) => {
  return (
    <svg viewBox="0 0 20 20" width={size} height={size} className={className} xmlns="http://www.w3.org/2000/svg">
      <defs>
        <radialGradient id="logo-grad-1" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(18.6 10.6) scale(41)">
          <stop stopColor="#A386FF" />
          <stop offset=".11" stopColor="#6B5BEA" />
          <stop offset=".23" stopColor="#3F2FBC" />
        </radialGradient>
        <linearGradient id="logo-grad-2" x1="18" y1="12.2" x2="10.8" y2="12.2" gradientUnits="userSpaceOnUse">
          <stop offset=".46" stopColor="#3C2CB8" stopOpacity="0" />
          <stop offset="1" stopColor="#10008F" />
        </linearGradient>
        <radialGradient id="logo-grad-3" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(2.4 6.2) rotate(68.2) scale(16.4)">
          <stop stopColor="#85C2FF" />
          <stop offset=".69" stopColor="#7588FF" />
          <stop offset="1" stopColor="#6459FE" />
        </radialGradient>
        <linearGradient id="logo-grad-4" x1="8.3" y1="7" x2="8.3" y2="19" gradientUnits="userSpaceOnUse">
          <stop offset=".8" stopColor="#6864F6" stopOpacity="0" />
          <stop offset="1" stopColor="#5149DE" />
        </linearGradient>
        <radialGradient id="logo-grad-5" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(14.5 3.8) rotate(-90) scale(5.8)">
          <stop offset=".27" stopColor="#6868F7" />
          <stop offset=".82" stopColor="#3923B1" />
        </radialGradient>
        <radialGradient id="logo-grad-6" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(7 2.1) rotate(-90) scale(6.9)">
          <stop offset=".27" stopColor="#8282FF" />
          <stop offset="1" stopColor="#3923B1" />
        </radialGradient>
        <radialGradient id="logo-grad-7" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(0 8) rotate(45) scale(12.7)">
          <stop offset=".05" stopColor="#688EFF" />
          <stop offset=".95" stopColor="#230F94" />
        </radialGradient>
      </defs>
      <path d="M9 8h6.1C16.7 8 18 9.3 18 10.9V16c0 1.66-1.34 3-3 3s-3-1.34-3-3v-5.1C12 9.3 10.7 8 9.1 8H9z" fill="url(#logo-grad-1)" />
      <path d="M9 8h6.1C16.7 8 18 9.3 18 10.9V16c0 1.66-1.34 3-3 3s-3-1.34-3-3v-5.1C12 9.3 10.7 8 9.1 8H9z" fill="url(#logo-grad-2)" fillOpacity="0.5" />
      <path d="M2 9.89C2 8.29 3.29 7 4.89 7h4.22C10.7 7 12 8.3 12 9.89V16c0 1.66 1.34 3 3 3l-8.04-.001C4.22 19 2 16.78 2 14.04V9.89z" fill="url(#logo-grad-3)" />
      <path d="M2 9.89C2 8.29 3.29 7 4.89 7h4.22C10.7 7 12 8.3 12 9.89V16c0 1.66 1.34 3 3 3l-8.04-.001C4.22 19 2 16.78 2 14.04V9.89z" fill="url(#logo-grad-4)" fillOpacity="0.7" />
      <circle cx="14.5" cy="4.5" r="2.5" fill="url(#logo-grad-5)" />
      <circle cx="7" cy="3" r="3" fill="url(#logo-grad-6)" />
      <rect y="8" width="9" height="9" rx="2" fill="url(#logo-grad-7)" />
      <path d="M6.4 10.9H5.07V15H3.93v-4.1H2.59V10H6.4v.9z" fill="#fff" />
    </svg>
  );
};

export default TeamsLogo;
